"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDurationBetweenGPSNodes = exports.addressesToMapLocations = exports.MARKER_ICON = exports.getMarkerDurationInMinutes = exports.setMarkerToTimeZone = exports.getLastStopMarker = exports.getStartMarker = exports.getLocationInfoText = exports.locationIcon = exports.getGPSInfo = exports.newGPSInfo = exports.PLACE_USER = void 0;
var _ = require("lodash");
var moment = require("moment");
var constants_1 = require("../constants");
var formatter_1 = require("../helpers/formatter");
require("moment-timezone");
var Place_1 = require("./Place");
exports.PLACE_USER = 'user';
var MARKER_INFO_TYPE_LABEL = 'Soort:';
var MARKER_INFO_NUMBER_LABEL = 'Nummer:';
var MARKER_INFO_STREET_LABEL = 'Straatnaam:';
var MARKER_INFO_CITY_LABEL = 'Plaatsnaam:';
var newGPSInfo = function () { return ({ paths: [], markers: [], gpsNodes: [] }); };
exports.newGPSInfo = newGPSInfo;
// Make some checks if the content is undefined
var getGPSInfo = function (dictionary, userId, date) {
    if (!dictionary[userId]) {
        dictionary[userId] = {}; // So won't fail later on
        return null;
    }
    if (!dictionary[userId][date]) {
        return null;
    }
    return dictionary[userId][date];
};
exports.getGPSInfo = getGPSInfo;
var locationIcon = function (type) {
    switch (type) {
        case exports.PLACE_USER:
            // if (userIsInLocation) return   'assets/icons/bussyWorker.png';
            return 'assets/icons/worker.svg';
        case Place_1.PlaceType.PROJECT: return 'assets/icons/project.svg';
        case Place_1.PlaceType.SERVICE_ORDER: return 'assets/icons/service.svg';
        case Place_1.PlaceType.SUPPLIER: return 'assets/icons/supplier.svg';
        case Place_1.PlaceType.OFFICE: return 'assets/icons/building.svg';
        default: return '';
    }
};
exports.locationIcon = locationIcon;
var getLocationInfoText = function (location) {
    var place;
    switch (location.type) {
        case exports.PLACE_USER:
            var userLocation = location;
            return userLocation.user.firstName + ' ' + userLocation.user.lastName;
        case Place_1.PlaceType.SERVICE_ORDER:
        case Place_1.PlaceType.PROJECT:
            place = location;
            return '<div id="marker-info">'
                + '<div class="row">'
                + '<div class="label">' + MARKER_INFO_NUMBER_LABEL + '</div>'
                + '<div class="value">' + place.number + '</div>'
                + '</div>'
                + '<div class="row">'
                + '<div class="label">' + MARKER_INFO_TYPE_LABEL + '</div>'
                + '<div class="value">' + place.type + '</div>'
                + '</div>'
                + '<div class="row">'
                + '<div class="label">' + MARKER_INFO_STREET_LABEL + '</div>'
                + '<div class="value">' + place.address + '</div>'
                + '</div>'
                + '<div class="row">'
                + '<div class="label">' + MARKER_INFO_CITY_LABEL + '</div>'
                + '<div class="value">' + place.city + '</div>'
                + '</div>'
                + '</div>';
        default:
            place = location;
            var address = place.address || {};
            return '<div id="marker-info">'
                + '<div class="row">'
                + '<div class="label">' + MARKER_INFO_NUMBER_LABEL + '</div>'
                + '<div class="value">' + place.name + '</div>'
                + '</div>'
                + '<div class="row">'
                + '<div class="label">' + MARKER_INFO_TYPE_LABEL + '</div>'
                + '<div class="value">' + place.type + '</div>'
                + '</div>'
                + '<div class="row">'
                + '<div class="label">' + MARKER_INFO_STREET_LABEL + '</div>'
                + '<div class="value">' + address.street + '</div>'
                + '</div>'
                + '<div class="row">'
                + '<div class="label">' + MARKER_INFO_CITY_LABEL + '</div>'
                + '<div class="value">' + address.city + '</div>'
                + '</div>'
                + '</div>';
    }
};
exports.getLocationInfoText = getLocationInfoText;
var getStartMarker = function (stepsList, timeZone) {
    if (timeZone === void 0) { timeZone = constants_1.DEFAULT_TIMEZONE; }
    var flattenSteps = _.flatten(stepsList);
    if (flattenSteps.length === 0) {
        return null;
    }
    var firstStep = flattenSteps[0];
    var firstMarker = {
        latitude: firstStep.latitude,
        longitude: firstStep.longitude,
        description: 'Vertrek: ' + moment(firstStep.recorded_at).tz(timeZone).format('HH:mm'),
        startTime: moment(firstStep.recorded_at).format('HH:mm'),
        endTime: moment(firstStep.recorded_at).format('HH:mm'),
    };
    return firstMarker;
};
exports.getStartMarker = getStartMarker;
var getLastStopMarker = function (stepsList, timeZone) {
    if (timeZone === void 0) { timeZone = constants_1.DEFAULT_TIMEZONE; }
    var flattenSteps = _.flatten(stepsList);
    if (flattenSteps.length === 0) {
        return null;
    }
    var lastStep = flattenSteps[flattenSteps.length - 1];
    var lastMarker = {
        latitude: lastStep.latitude,
        longitude: lastStep.longitude,
        description: 'Aankomst: ' + moment(lastStep.recorded_at).tz(timeZone).format('HH:mm'),
        startTime: moment(lastStep.recorded_at).format('HH:mm'),
        endTime: moment(lastStep.recorded_at).format('HH:mm'),
    };
    return lastMarker;
};
exports.getLastStopMarker = getLastStopMarker;
// Set the marker stop into time zone. For example, the times comming to china get also in dutch to
// match the rest of information. (When we can display)
var setMarkerToTimeZone = function (marker, timeZone) {
    if (timeZone === void 0) { timeZone = constants_1.DEFAULT_TIMEZONE; }
    // Marker startTime and endTime is just the hour format
    var description = moment(marker.startTime, 'HH:mm').tz(timeZone).format('HH:mm') + ' - ' +
        moment(marker.endTime, 'HH:mm').tz(timeZone).format('HH:mm');
    return __assign(__assign({}, marker), { description: description });
};
exports.setMarkerToTimeZone = setMarkerToTimeZone;
var getMarkerDurationInMinutes = function (marker) {
    var minuteArray = marker.description.split('-'); // 10:00-11:00
    if (minuteArray.length === 1) { // 11:00 , so he stop for 1 or less minutes
        return 1;
    }
    var hours = formatter_1.Hour.inputFormatToDuration(minuteArray[1]) - formatter_1.Hour.inputFormatToDuration(minuteArray[0]);
    return Math.round(hours * 60);
};
exports.getMarkerDurationInMinutes = getMarkerDurationInMinutes;
exports.MARKER_ICON = 'assets/icons/marker.svg';
// MapLocation is ready to be displayed in google Maps
var addressesToMapLocations = function (addresses) {
    // Transform the uniq addresses in map locations that can be displayed
    var mapLocations = _.uniqBy(addresses, '_id')
        .map(function (projectAddress) {
        var coords = projectAddress.coords ?
            { latitude: projectAddress.coords[1], longitude: projectAddress.coords[0] } : { latitude: 0, longitude: 0 };
        return {
            _id: projectAddress._id,
            type: projectAddress.type,
            place: projectAddress,
            coords: coords,
        };
    });
    return mapLocations;
};
exports.addressesToMapLocations = addressesToMapLocations;
var getDurationBetweenGPSNodes = function (previous, next) {
    return moment.duration(moment(next.start_time).diff(moment(previous.end_time))).asHours();
};
exports.getDurationBetweenGPSNodes = getDurationBetweenGPSNodes;
